import { isArray, pickBy } from 'lodash';
import { getOrderURLById } from '../../utils/parsers';
import { serializeAttachments } from './attachment';
import { ORDER_STATUSES } from '../../constants/orders';

import checkNullableValue from '../../utils/checkNullableValue';

const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const createDetails = ({
  month, day, kidsAges = [], kidsCount = 0, nights, adultsCount,
}) => {
  const parts = [];

  if (day && month != null && months[month]) {
    parts.push(`${day} ${months[month]}`);
  } else if (day) {
    parts.push(`${day}`);
  } else if (month != null && months[month]) {
    parts.push(`${months[month]}`);
  }

  if (nights != null) {
    parts.push(`${nights} н.`);
  }

  parts.push(`${adultsCount} взр.`);

  if (kidsCount > 0 && kidsAges.length > 0) {
    const ages = kidsAges.join(', ');
    parts.push(`${kidsCount} дет. (${ages} лет)`);
  }

  return parts.join(', ');
};

export const isStateActive = state =>
  ![
    ORDER_STATUSES.CANCELED,
    ORDER_STATUSES.DEPOSIT,
    ORDER_STATUSES.ANNULLED,
    ORDER_STATUSES.SURVEY_COMPLETED,
    ORDER_STATUSES.GOT_BACK,
  ].includes(state);

export const serializeOrder = order => {
  const date = new Date(order.start_date);
  const attachments = [
    ...serializeAttachments(order.attachments),
    ...serializeAttachments(order.custom_attachments),
  ];

  return {
    id: order.id?.toString(),
    clientId: order.client_id,
    ticketIds: order.ticket_ids && (isArray(order.ticket_ids) || []) && order.ticket_ids?.map((id) => id.toString()),
    name: order.client_full_name,
    adultsCount: order.adults_count,
    kidsCount: order.kids_count,
    startDate: order.start_date,
    nightsCount: order.nights_count,
    kidsAges: order.kids_ages,
    countryCode: order.country_code,
    departureName: order.departure_name,
    region: order.region_name,
    hasFlights: order.has_flights,
    hotelName: order.hotel_name,
    status: order.state,
    active: order.state && isStateActive(order.state),
    subAgentName: order.sub_agent_name,
    attachments: order.attachments && attachments,
    details: order.nights_count && order.adults_count && createDetails({
      month: order.start_date ? date.getMonth() : null,
      day: order.start_date ? date.getDate() : null,
      nights: order.nights_count,
      kidsAges: order.kids_ages,
      kidsCount: order.kids_count,
      adultsCount: order.adults_count,
    }),
    href: order.id && getOrderURLById(order.id),
  };
};

export const serializeOrders = orders => {
  if (!isArray(orders) || orders.length < 1) return null;

  return orders.map((order) => pickBy(serializeOrder(order), checkNullableValue));
};

export const getOrdersAttachments = orders => {
  if (!isArray(orders) || orders.length < 1) return null;

  return orders.reduce(
    (prev, { attachments }) => (attachments ? [...prev, ...attachments] : prev),
    []
  );
};

export const sortOrdersByDateAndActive = orders => {
  if (!isArray(orders) || orders.length < 1) return null;

  return orders.sort((orderB, orderA) => {
    if (orderA.startDate < orderB.startDate) return -1;
    if (orderA.startDate > orderB.startDate) return 1;

    if (orderA.active && !orderB.active) return -1;
    if (!orderA.active && orderB.active) return 1;

    return 0;
  });
};
